import React from 'react';
import { createContainer } from 'react-tracked';
export var ConversionNudgeType;
(function (ConversionNudgeType) {
    ConversionNudgeType["GUIDE"] = "guide";
    ConversionNudgeType["MILESTONE"] = "milestone2";
    ConversionNudgeType["NEED_HELP"] = "need_help";
})(ConversionNudgeType || (ConversionNudgeType = {}));
export var TriggerNudgeType;
(function (TriggerNudgeType) {
    TriggerNudgeType["NONE"] = "";
    TriggerNudgeType["BOOK_1_1"] = "BOOK_1_1";
    TriggerNudgeType["VIEW_PRICE"] = "VIEW_PRICE";
})(TriggerNudgeType || (TriggerNudgeType = {}));
export var FullUserJourneyBlinkActionType;
(function (FullUserJourneyBlinkActionType) {
    FullUserJourneyBlinkActionType[FullUserJourneyBlinkActionType["UPDATE_FULL_USER_JOURNEY_GLOBAL_CONTEXT"] = 0] = "UPDATE_FULL_USER_JOURNEY_GLOBAL_CONTEXT";
})(FullUserJourneyBlinkActionType || (FullUserJourneyBlinkActionType = {}));
export const defaultFullUserJourneyContextOptions = {
    connectOwnDataErrorOccurred: false,
};
const reducer = (state = defaultFullUserJourneyContextOptions, action) => {
    switch (action.type) {
        case FullUserJourneyBlinkActionType.UPDATE_FULL_USER_JOURNEY_GLOBAL_CONTEXT:
            return { ...state, ...action.data };
        default:
            return state;
    }
};
const getDispatcherFunctions = (dispatch) => ({
    updateFullUserJourneyGlobalContext: (data) => {
        dispatch({
            type: FullUserJourneyBlinkActionType.UPDATE_FULL_USER_JOURNEY_GLOBAL_CONTEXT,
            data,
        });
    },
});
function getOrCreateContainer() {
    var _a;
    if ((_a = window === null || window === void 0 ? void 0 : window.blink) === null || _a === void 0 ? void 0 : _a.fullUserJourneyBlinkContainer) {
        return window.blink.fullUserJourneyBlinkContainer;
    }
    const { Provider, useTrackedState, useUpdate } = createContainer(({ initialState }) => React.useReducer(reducer, initialState));
    const container = {
        Provider,
        useTrackedState,
        useDispatch: useUpdate,
    };
    window.blink = window.blink || {};
    window.blink.fullUserJourneyBlinkContainer = container;
    return container;
}
const { Provider: InternalProvider, useTrackedState, useDispatch, } = getOrCreateContainer();
const FullUserJourneyContextProvider = ({ children, value = {}, }) => (React.createElement(InternalProvider, { initialState: { ...defaultFullUserJourneyContextOptions, ...value } }, children));
const getFullUserJourneyGlobalContext = () => {
    try {
        return useTrackedState() || defaultFullUserJourneyContextOptions;
    }
    catch (e) {
        if (/Please use <Provider>/.test(e === null || e === void 0 ? void 0 : e.message)) {
            return {};
        }
        throw e;
    }
};
const setFullUserJourneyGlobalContext = () => {
    const dispatch = useDispatch();
    return dispatch
        ? getDispatcherFunctions(dispatch)
        : {};
};
export { FullUserJourneyContextProvider, getFullUserJourneyGlobalContext, setFullUserJourneyGlobalContext, };
//# sourceMappingURL=full-user-journey-context.js.map